import React, { useState } from 'react';
import classNames from 'classnames';

import css from './EmailSignupForm.module.css';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailSignupForm = props => {
  const { source = 'footer', className } = props;

  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    const trimmed = email.trim();
    if (!trimmed) {
      setStatus('error');
      setErrorMessage('Please enter your email.');
      return;
    }
    if (!EMAIL_REGEX.test(trimmed)) {
      setStatus('error');
      setErrorMessage('Please enter a valid email.');
      return;
    }

    setStatus('submitting');
    setErrorMessage('');

    try {
      const res = await fetch('/api/klaviyo-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed, source }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setStatus('success');
      } else {
        setStatus('error');
        setErrorMessage(data.error || 'Something went wrong. Please try again.');
      }
    } catch {
      setStatus('error');
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  if (status === 'success') {
    return (
      <div className={classNames(css.root, className)}>
        <p className={css.success}>You're on the list.</p>
      </div>
    );
  }

  const isSubmitting = status === 'submitting';

  return (
    <div className={classNames(css.root, className)}>
      <form className={css.form} onSubmit={handleSubmit} noValidate>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Your email"
          className={classNames(css.input, { [css.inputError]: status === 'error' })}
          disabled={isSubmitting}
          aria-label="Email address"
        />
        <button type="submit" className={css.button} disabled={isSubmitting}>
          {isSubmitting ? 'Joining...' : 'Join'}
        </button>
      </form>
      {status === 'error' && errorMessage ? (
        <p className={css.error}>{errorMessage}</p>
      ) : null}
    </div>
  );
};

export default EmailSignupForm;
